import { Transforms, Element, Node } from 'slate';
import {
  LIST_ITEM_DEFINITIONS,
  ORDERED_LIST_DEFINITIONS,
  UNORDERED_LIST_DEFINITIONS,
} from '@xingternal/content-editor-plugin-helpers';

const withLists = (editor) => {
  const { normalizeNode } = editor;

  editor.normalizeNode = (entry) => {
    const [node, path] = entry;

    // make sure lists are flat, i.e. all un|ordered-list child are list-items
    if (
      Element.isElement(node) &&
      (node.type === ORDERED_LIST_DEFINITIONS.type ||
        node.type === UNORDERED_LIST_DEFINITIONS.type)
    ) {
      for (const [child, childPath] of Node.children(editor, path)) {
        if (
          Element.isElement(child) &&
          child.type !== LIST_ITEM_DEFINITIONS.type
        ) {
          Transforms.liftNodes(editor, { at: childPath });
          return;
        }
      }
    }

    normalizeNode(entry);
  };

  return editor;
};

export { withLists };
